export default "__VITE_ASSET__BnnRzvvG__"